module.exports = __webpack_public_path__ + "static/coph5-3593b197dab27d503a8a2429941cf54a.jpg";